import * as React from 'react';
import { Route } from 'react-router-dom';
import AssetDataOverviewHOC from '../../shared/dataSharing/AssetDataOverview';
import AssetDataDetailsHOC from '../../shared/dataSharing/AssetDataDetails';
import DataSharingService from '../../shared/services/DataSharingService';
import { Status } from '../../shared/constants';

const Label = {
  Status: {
    [Status.New]: 'New provider',
    [Status.Requested]: 'Request sent',
    [Status.RequestDeclined]: 'Request declined',
    [Status.Offered]: 'Offer received',
    [Status.OfferDeclined]: 'Offer declined',
    [Status.Accepted]: 'Active',
    [Status.Expiring]: 'Expiring',
    [Status.ExpiringReplaced]: 'Expiring replaced',
    [Status.Scheduled]: 'Scheduled',
    [Status.Suspended]: 'Stopped',
    [Status.SuspendedReplaced]: 'Stopped replaced',
  },
  Action: {
    [Status.New]: 'Request',
    [Status.Requested]: 'View details',
    [Status.RequestDeclined]: 'Reply',
    [Status.Offered]: 'Reply',
    [Status.OfferDeclined]: 'View details',
    [Status.Accepted]: 'Reply',
    [Status.Expiring]: 'Reply',
    [Status.ExpiringReplaced]: 'View details',
    [Status.Scheduled]: 'View details',
    [Status.Suspended]: 'Reply',
    [Status.SuspendedReplaced]: 'View details',
  },
  Entity: {
    Name: 'data provider',
  },
};

const DataProperty = {
  Entity: 'data',
};

const OverviewConfiguration = {
  GetAgreements: DataSharingService.GetDataUserAgreements,
};

const DetailsConfiguration = {
  [Status.New]: {
    sendRemark: true,
    sendFees: false,
    sendDurationMonths: false,
    actions: {
      sendRequest: {
        label: 'Send request',
        successMessage: 'Successfully sent request.',
        onAction: (state: any) => {
          return DataSharingService.PostAgreementStateChange(
            state.agreement.id,
            Status.Requested, 
            state.agreement.currency,
            state.remark
          );
        },
      },
    },
  },
  [Status.Requested]: {
    sendRemark: false,
    sendFees: false,
    sendDurationMonths: false,
    actions: {},
  },
  [Status.RequestDeclined]: {
    sendRemark: true,
    sendFees: false,
    sendDurationMonths: false,
    actions: {
      sendAnotherRequest: {
        label: 'Send another request',
        successMessage: 'Successfully sent another request.',
        onAction: (state: any) => {
          return DataSharingService.PostAgreementStateChange(
            state.agreement.id,
            Status.Requested,
            state.agreement.currency,
            state.remark
          );
        },
      },
    },
  },
  [Status.Offered]: {
    sendRemark: true,
    sendFees: false,
    sendDurationMonths: false,
    actions: {
      declineOffer: {
        label: 'Decline offer',
        successMessage: 'Successfully declined offer.',
        onAction: (state: any) => {
          return DataSharingService.PostAgreementStateChange(
            state.agreement.id,
            Status.OfferDeclined,
            state.agreement.currency,
            state.remark
          );
        },
      },
      acceptOffer: {
        label: 'Accept offer',
        successMessage: 'Successfully accepted offer.',
        onAction: (state: any) => {
          return DataSharingService.PostAgreementStateChange(
            state.agreement.id,
            Status.Accepted,
            state.agreement.currency,
            state.remark
          );
        },
      },
    },
  },
  [Status.OfferDeclined]: {
    sendRemark: false,
    sendFees: false,
    sendDurationMonths: false,
    actions: {},
  },
  [Status.Accepted]: {
    sendRemark: true,
    sendFees: false,
    sendDurationMonths: false,
    actions: {
      stop: {
        label: 'Stop agreement',
        successMessage: 'Successfully expired offer.',
        onAction: (state: any) => {
          return DataSharingService.PostAgreementStateChange(
            state.agreement.id,
            Status.Expiring,
            state.agreement.currency,
            state.remark,
          );
        },
        areYouSure: 'This action will expire your active agreement.',
      },
      newRequest: {
        label: 'Send new request',
        successMessage: 'Successfully sent new request.',
        onAction: (state: any) => {
          return DataSharingService.PostAgreementStateChange(
            state.agreement.id,
            Status.Requested,
            state.agreement.currency,
            state.remark,
          );
        },
        areYouSure: 'This action will expire your active agreement.',
      },
    },
  },
  [Status.Expiring]: {
    sendRemark: true,
    sendFees: false,
    sendDurationMonths: false,
    actions: {
      newRequest: {
        label: 'Send new request',
        successMessage: 'Successfully sent new request.',
        onAction: (state: any) => {
          return DataSharingService.PostAgreementStateChange(
            state.agreement.id,
            Status.Requested,
            state.agreement.currency,
            state.remark,
          );
        },
      },
    },
  },
  [Status.ExpiringReplaced]: {
    sendRemark: false,
    sendFees: false,
    sendDurationMonths: false,
    actions: {},
  },
  [Status.Scheduled]: {
    sendRemark: false,
    sendFees: false,
    sendDurationMonths: false,
    actions: {},
  },
  [Status.Suspended]: {
    sendRemark: true,
    sendFees: false,
    sendDurationMonths: false,
    actions: {
      newRequest: {
        label: 'Send new request',
        successMessage: 'Successfully sent new request.',
        onAction: (state: any) => {
          return DataSharingService.PostAgreementStateChange(
            state.agreement.id,
            Status.Requested,
            state.agreement.currency,
            state.remark,
          );
        },
      },
    },
  },
  [Status.SuspendedReplaced]: {
    sendRemark: false,
    sendFees: false,
    sendDurationMonths: false,
    actions: {},
  },
};

const ConsumerAssetDataOverview = AssetDataOverviewHOC(Label, DataProperty, OverviewConfiguration);
const ConsumerAssetDataDetails = AssetDataDetailsHOC(Label, DataProperty, DetailsConfiguration);

class ConsumerAssetData extends React.Component<any, any> {
  public get basePath() {
    return `/subscriptions/${this.props.assetId}/${this.props.environment}/data`;
  }

  public getConsumerAssetDataOverviewWithProps = (routeProps: any) => {
    return <ConsumerAssetDataOverview {...routeProps} assetId={this.props.assetId} basePath={this.basePath} />;
  };
  
  public getConsumerDataDetailsWithProps = (routeProps: any) => {
    return <ConsumerAssetDataDetails {...routeProps} asset={this.props.asset}/>
  }
  

  public render() {
    return (
      <React.Fragment>
        <Route path={this.basePath} exact render={this.getConsumerAssetDataOverviewWithProps} />
        <Route path={this.basePath + '/:agreementId'} exact render={this.getConsumerDataDetailsWithProps} />
      </React.Fragment>
    );
  }
}

export default ConsumerAssetData;



// WEBPACK FOOTER //
// ./src/modules/consumer/pages/ConsumerAssetData.tsx